import React from "react";
import VolumeSalesLineChart from "./VolumeSalesLineChart";
import SalesLineChart from "./SalesLineChart";
import StationFuelBalancesChart from "./StationFuelBalancesChart";
import AttendantSalesLitersBarChart from "./AttendantSalesLitersBarChart";
function StationGraphs() {
  return (
    <div className="col-sm-12 col-xl-12 col-lg-12 col-md-12">
      <div className="row row-sm">
        <div className="col-sm-12 col-xl-12 col-lg-12 col-md-12">
          <div className="card custom-card overflow-hidden">
            <div className="card-body">
              <div className="card-option d-flex">
                <div className="card-option-title ml-auto">
                  <div className="btn-group p-0">
                    <button className="btn btn-light btn-sm" type="button">
                      Today
                    </button>
                  </div>
                </div>
              </div>
              <div style={{ width: "100%", height: "auto" }}>
                <AttendantSalesLitersBarChart />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default StationGraphs;
